import React, { useEffect } from 'react';
import Loading from '../../../core/layouts/main/loading/loading';
import Layout from '../../../core/layouts/main';
import { AccountController } from '../../../core/config/controllers/AccountController';
import { DateHelper } from '../../../core/config/helpers/DateHelper';
import Storage from '../../../core/config/helpers/Storage';

export default function Users() {
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [sidebarOpen, setSidebarOpen] = React.useState(false);

  useEffect(() => {
    loadUsers()
  }, [])

  useEffect(() => {
    Storage.isAuthenticated();
  }, []);

  function loadUsers() {
    AccountController.List(res => setData(res));
  }

  function limparTelefone(telefone) {
    if (!telefone) return
    return telefone.replace(/\D/g, '');
  }

  return (
    <Layout showSideOverlay={sidebarOpen}>
      <Loading loading={loading} />
      <div className='content'>
        <h1 className='content-heading'>Usuários</h1>
        <div className='row'>
          <div className='col-md-12'>
            <div class="input-group input-group-lg">
              <input type="text" class="js-icon-search form-control" placeholder="Filtrar por qualquer dado..." />
              <span class="input-group-text">
                <i class="fa fa-search"></i>
              </span>
            </div>
            <table className='table table-hover table-striped table-vcenter'>
              <thead>
                <tr>
                  <td>Nome</td>
                  <td>Email</td>
                  <td>Celular</td>
                  <td>Último acesso</td>
                  <td>Criado em</td>
                  <td></td>
                </tr>
              </thead>
              <tbody>
                {data && data.map(item => (
                  <tr>
                    <td>{item.display_name}</td>
                    <td>{item.email}</td>
                    <td>{item.phone_number !== undefined ?
                      <a className='btn btn-dual' href={`https://wa.me/${limparTelefone(item.phone_number)}`} target='_blank'>
                        {item.phone_number}
                      </a>
                      : ""}</td>
                    <td>{typeof item.updated_time === "string" ? item.updated_time : DateHelper.DateTranslate(item.updated_time)}</td>
                    <td>{typeof item.created_time === "string" ? item.created_time : DateHelper.DateTranslate(item.created_time)}</td>
                    <td>
                      <a className='btn btn-dual' href={`#/user/?userId=${item.id}`} target='_blank'>
                        <i className='far fa-eye' />
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Layout>
  );
};